module.exports = __webpack_public_path__ + "static/media/icon-manufacturing.ccdde225.svg";